import { Box, FlexBox, H1, Spinner, StandardForm } from '@vp/swan'
import { useTranslation } from 'react-i18next'
import { useContactDetails } from '../../hooks/use-contact-details'
import { ChannelStatusAlert } from './alerts/channel-status-alert'
import { ContactDetailsAuthBar } from './auth/contact-details-auth-bar'
import { ContactEmailField } from './fields/contact-email-field'
import { ContactPhoneField } from './fields/contact-phone-field'
import { IntentField } from './fields/intent-field'
import { NameFields } from './fields/name-fields'
import { PrivacyCookieField } from './fields/privacy-cookie-field'

export const ContactDetails = () => {
  const { t } = useTranslation()
  const { control, channel, isLoading, isSignedIn, profileEmail, displayName, title, channelStatusAlertKey } = useContactDetails()

  if (isLoading) {
    return (
      <FlexBox justifyContent="center" alignItems="center" style={{ minHeight: '300px' }}>
        <Spinner accessibleText={t('contact_us.page.steps.details.loading')} />
      </FlexBox>
    )
  }

  return (
    <Box data-testid="step-contact-details">
      <H1 mb={6} fontSkin="title-headline">
        {title}
      </H1>

      <ContactDetailsAuthBar isSignedIn={isSignedIn} profileEmail={profileEmail} displayName={displayName} />

      {channelStatusAlertKey && (
        <Box mb={7} data-testid="channel-status-alert" data-alert-key={channelStatusAlertKey}>
          <ChannelStatusAlert alertKey={channelStatusAlertKey} />
        </Box>
      )}

      <StandardForm>
        <IntentField control={control} />
        <NameFields control={control} />
        <ContactEmailField control={control} />
        {channel === 'callback' && <ContactPhoneField control={control} />}
        {channel === 'callback' && <PrivacyCookieField control={control} />}
      </StandardForm>
    </Box>
  )
}
